/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class TeamsAPI extends CacheEnabledApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'team';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  getAgents({ teamId }) {
    return axios.get(`${this.url}/${teamId}/team_members`);
  }

  addAgents({ teamId, agentsList, followMeList }) {
    return axios.post(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
      follow_me_ids: followMeList,
    });
  }

  getFollowers({ teamId }) {
    return axios.get(`${this.url}/${teamId}/team_members/followers`);
  }

  updateAgents({ teamId, agentsList, followMeList }) {
    return axios.patch(`${this.url}/${teamId}/team_members`, {
      user_ids: agentsList,
      follow_me_ids: followMeList,
    });
  }
}

export default new TeamsAPI();
